import {default as localForage} from "localforage";

let diffInSeconds = (t1:Date, t2:Date) => {
    return Math.abs((t1.getTime() - t2.getTime()) / 1000);
};

interface ICacheItem {
    saved: Date;
    ttl: number;
    data: any;
}

const cachePrefix = (x:string) => `__tarrita__${x}`;


export async function get<T>(key: string) : Promise<T | null> {
    const res:ICacheItem = <ICacheItem>await localForage.getItem(cachePrefix(key));
    if (!res) {
        return Promise.resolve(null);
    }
    let now = new Date();

    if (!res.saved || typeof res.saved.getMonth !== 'function') {
        return Promise.resolve(null);
    }
    // let seconds = diffInSeconds(res.saved, now);
    // if (seconds > res.ttl) return Promise.resolve(null);
    return <T>res.data;
}

export async function save(key:string, data:any, ttl = -1) {
    const save: ICacheItem = {
        saved: new Date(),
        ttl,
        data
    };
    console.warn(`saving ${key}`, data)
    return localForage.setItem(cachePrefix(key), save);
}


export async function cacheOrFetch(resource:string) {
    const res = await get(resource);
    if (res === null) {
        const r = await (await fetch(resource)).json()
        await save(resource, r);
        return r;
    } else {
        console.warn(`Returning ${resource} from cache`);
    }
    return res;
}


export async function cacheOrFetchUpdatedResponse(resource:string, alwaysNetwork: (res:any) => { }) {
    console.log('cacheOrFetchUpdatedResponse');
    const res = await get(resource);
    if (res === null) {
        const r = await (await fetch(resource)).json();
        await save(resource, r);
        return r;
    } else {
        setTimeout(async () => {
            console.log('Called timeout')
            const r = await (await fetch(resource)).json()
            await save(resource, r);
            console.log(`Updated ${resource} response`)
            alwaysNetwork(r);
        }, 0);
        console.warn(`Returning ${resource} from cache`);
    }
    return res;
}


export async function clearAll() {
    return localForage.clear();
}